import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/utils/apiFetch';

type TermsAndPrivacyUpdate = {
  termsMarkdown?: string;
  privacyMarkdown?: string;
  version: number;
};

export const termsAndPrivacyKeys = {
  updates: ['termsAndPrivacy', 'updates'] as const,
};

const useGetTermsAndPrivacyUpdates = () => {
  const { data, ...rest } = useQuery({
    queryKey: termsAndPrivacyKeys.updates,
    queryFn: async (): Promise<TermsAndPrivacyUpdate | null> => {
      const response = await apiFetch('/api/users/terms_and_privacy_updates');

      if (!response.ok) return null;

      const body = await response.json();
      return body || null;
    },
  });

  return { data: data ?? null, ...rest };
};

export default useGetTermsAndPrivacyUpdates;
